import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import Logo from "../components/site/Logo";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F0F5F2] px-6" data-testid="login-page">
      <div className="w-full max-w-md">
        <Link
          to="/"
          className="mb-6 inline-flex items-center gap-2 text-sm text-[#4A6657] hover:text-[#0B281B]"
          data-testid="login-back-home"
        >
          <ArrowLeft className="h-4 w-4" /> Back to site
        </Link>

        <div className="rounded-3xl border border-[#DCECE3] bg-white p-8 shadow-[0_8px_40px_rgba(11,40,27,0.06)]">
          <Logo />
          <h1 className="mt-6 font-heading text-2xl font-medium text-[#0B281B]">
            Admin login
          </h1>
          <p className="mt-1 text-sm text-[#4A6657]">
            Sign in to view and manage your leads.
          </p>

          <form onSubmit={submit} className="mt-7 space-y-5" data-testid="login-form">
            <label className="block">
              <span className="mb-2 block text-sm font-medium text-[#0B281B]">Email</span>
              <input
                type="email"
                data-testid="login-email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@sprigbuilt.com"
                className="w-full rounded-xl border border-[#DCECE3] bg-white px-4 py-3 text-[#0B281B] focus:outline-none focus:ring-2 focus:ring-[#98D8BA]"
              />
            </label>
            <label className="block">
              <span className="mb-2 block text-sm font-medium text-[#0B281B]">Password</span>
              <input
                type="password"
                data-testid="login-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="w-full rounded-xl border border-[#DCECE3] bg-white px-4 py-3 text-[#0B281B] focus:outline-none focus:ring-2 focus:ring-[#98D8BA]"
              />
            </label>
            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit"
              className="inline-flex w-full items-center justify-center rounded-full bg-[#0B281B] px-8 py-4 font-medium text-white transition-colors hover:bg-[#1A3F2C] disabled:opacity-60"
            >
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
